














import * as shared from '../../shared'
import Topic from './comps/topic.vue'
import weibo from './comps/weibo.vue'
import fixedTop from './comps/fixedTop.vue'
import fixedBottom from './comps/fixedBottom.vue'
import * as utils from '@ivy/fts/utils'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component({
  components: {
    Topic,
    weibo,
    fixedTop,
    fixedBottom,
  },
})
export default class TopicPage extends Vue {
  weibo: any = []
  topic: any = {}
  async mounted() {
    // utils.trackEvent(`社区话题页`, '访问')
    this.topic = await shared.getTopic(this.$route.query.id)
    this.weibo = await shared.getWeiboList(this.$route.query.id)
  }
}
